import { useSearchParams } from 'react-router-dom';

export const useCandidateSearchParams = () => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');
  const candidateId = searchParams.get('candidateId');

  return { candidateId, token };
};
